import React from 'react'
import {
  metersToDisplayDistance, metersToElev, mpsToSpeed,
  distanceUnit, elevUnit, speedUnit, formatDuration
} from '../../../../../lib/trackStats'

// Condensed on-map stat capsule shown while editing (design spec §4). Fixed over the
// visible map area (right of the 88px rail + 420px panel).
const StatCapsule = ({ stats, units }) => {
  const cells = [
    { label: 'Distance', value: metersToDisplayDistance(stats.distanceM || 0, units).toFixed(2), unit: distanceUnit(units) },
    { label: 'Duration', value: formatDuration(stats.realTripTimeS || stats.tripTime || 0), unit: '' },
    { label: 'Elev Gain', value: Math.round(metersToElev(stats.elevationGainM || 0, units)).toLocaleString(), unit: elevUnit(units), color: '#9ECC3B' },
    { label: 'Top Spd', value: mpsToSpeed(stats.maxSpeedMps || 0, units).toFixed(1), unit: speedUnit(units) }
  ]
  return (
    <div className="td-capsule-wrap">
      <div className="td-capsule">
        {cells.map((c, i) => (
          <React.Fragment key={c.label}>
            {i > 0 && <div className="td-capsule-divider" />}
            <div className="td-capsule-cell">
              <div className="td-capsule-value" style={c.color ? { color: c.color } : null}>
                {c.value}{c.unit ? <span className="td-capsule-unit">{c.unit}</span> : null}
              </div>
              <div className="td-capsule-label">{c.label}</div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default StatCapsule
